import React from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { Settings } from "@mui/icons-material";
import { useAuthenticationStore } from "../../../stores/auth";
import { useNavigate } from "react-router-dom";
import FruitifyIcon from "../../../shared-components/FruitifyIcons";

const AdminDashboardAction = ({ title, subtitle, iconName, onClick }) => {
  return (
    <Card variant="outlined" data-testid={`${title}-card`}>
      <FruitifyIcon name={iconName} variant="background" />
      <CardContent sx={{ mt: 2, mb: 2 }}>
        <Typography variant="h5">{title}</Typography>
        <Typography variant="subtitle1">{subtitle}</Typography>
      </CardContent>
      <Button
        sx={{ width: "100%" }}
        variant="outlined"
        startIcon={<Settings />}
        onClick={onClick}
      >
        Manage
      </Button>
    </Card>
  );
};

function AdministratorDashboard() {
  const { user } = useAuthenticationStore();
  const navigate = useNavigate();
  return (
    <FruitifyContainer>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        gap={2}
        sx={{ mb: 3 }}
      >
        <Avatar />

        <Box>
          <Typography variant="h5">
            Welcome back, {user.info.firstName}!
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={4} direction={"row"}>
        <Grid size={{ xs: 12, md: 4 }}>
          <AdminDashboardAction
            title={"Manage classes"}
            subtitle={
              "Manage classes including class creation and allocation of teachers and students"
            }
            iconName={"School"}
            onClick={() => navigate("/management/classes")}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <AdminDashboardAction
            title={"Manage teachers"}
            subtitle={
              "Manage teachers including adding new members and allocating to classes"
            }
            iconName={"Teacher"}
            onClick={() => navigate("/management/teachers")}
          />
        </Grid>{" "}
        <Grid size={{ xs: 12, md: 4 }}>
          <AdminDashboardAction
            title={"Manage students"}
            subtitle={
              "Manage students including adding students and allocating to classes"
            }
            iconName={"Student"}
            onClick={() => navigate("/management/students")}
          />
        </Grid>
      </Grid>
    </FruitifyContainer>
  );
}

export default AdministratorDashboard;
